import Util from 'root/module/util';
import Modals from 'root/modals';
import View from 'view/base';

export default View.extend({
    events: {
        'click' : 'onClick'
    },

    dom_handlers: {
        onClick: function(e) {
            Modals.openUserIdentification(this.model.get('identification'));
        }
    },

    render: function() {
        var content =
        '<div class="flex-between">' +
            '<div class="badge-id">' + this.model.escape('identification') + '</div>' +
            '<div class="text-info">' + Util.moment(this.model.get('last_seen')) + '</div>' +
        '</div>' +
        '<div class="text-default margin-top-8">' + (this.model.escape('display_name') || '-') + '</div>' +
        '<div class="text-default margin-top-4">' + (this.model.escape('email') || '-') + '</div>';

        this.$el.html(content);

        return this;
    }
});